export default "__VITE_ASSET__aIhO6O3i__"